export const experience = [
  {
    id: 0,
    company: "Stride",
    position: "Fullstack Engineer",
    location: "Remote, Singapore",
    country: "Singapore",
    code: "SG",
    period: "March 2026 - Present",
    responsibilities: [
      "Work directly with the Founder and COO to design and build core features for an AI-powered CRM platform, turning product requirements into scalable technical solutions",
      "Own end-to-end feature development across the stack — React/Next.js frontend, Node.js backend services, RESTful API integration, PostgreSQL schema design, and system architecture",
      "Design and optimize database schemas, business workflows, and application architecture for scalability, maintainability, and platform performance",
      "Build and integrate AI features and automation workflows to extend CRM functionality and user experience",
    ],
  },
  {
    id: 1,
    company: "Newgen Development",
    position: "Fullstack Engineer",
    location: "Remote, Malaysia",
    country: "Malaysia",
    code: "MY",
    period: "March 2026 - Present",
    responsibilities: [
      "Built the Polareis.io marketing website in Next.js — 7+ feature & audience-segmented subpages with dynamic content sourced from Google Sheets and Figma references",
      "Shipped a headless e-commerce MVP integrating the WooCommerce REST API with Next.js, including server-side API security and dual payment gateways (Stripe & Midtrans)",
      "Solo-built the Ez5050 prediction platform — a bilingual landing page with a live market ticker, plus a CMS with image upload/positioning and auto-translation to 3 languages on save",
    ],
  },
  {
    id: 2,
    company: "Software Fintools",
    position: "Frontend Developer",
    location: "Remote, Indonesia",
    country: "Indonesia",
    code: "ID",
    period: "June 2025 - February 2026",
    responsibilities: [
      "Delivered a 9-month enterprise financial web application for PT Viura Indo Tirta at 100% scope completion, on spec and on time",
      "Architected ±50 reusable UI components on Atomic Design principles using React, TypeScript, Redux Toolkit & Tailwind CSS — accelerating feature delivery by up to 40%",
      "Implemented real-time data sync with Redux + WebSocket, eliminating manual page refresh (100%) and keeping data consistent across users",
    ],
  },
  {
    id: 3,
    company: "PT Jagoscript Inovasi Digital",
    position: "Frontend Developer",
    location: "Remote, Indonesia",
    country: "Indonesia",
    code: "ID",
    period: "January 2025 - June 2025",
    responsibilities: [
      "Built responsive, mobile-first interfaces for ±5 application modules using Tailwind CSS and modern CSS",
      "Optimized performance with Livewire real-time components, cutting average load time by ~45%",
    ],
  },
  {
    id: 4,
    company: "PT 4NET Prima Solusi",
    position: "Fullstack Developer",
    location: "Depok, Indonesia",
    country: "Indonesia",
    code: "ID",
    period: "January 2024 - July 2024",
    responsibilities: [
      "Built a full-stack clinic queue management system, improving operational efficiency through digital automation",
      "Developed a vehicle shipment simulation API in TypeScript & Prisma with dimensional-fitting logic to determine whether motorcycles or cars fit container specs",
      "Designed RESTful APIs and managed 3 integrated databases while maintaining performance through the deployment phase",
    ],
  },
];
